import service from "@/helpers/py-service";

const state = {
  isLoading: false,
  meta: {},
  list: [],
  //
};  

const mutations = {
  SET_META(state, payload) {
    state.meta = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  ADD_LIST(state, payload) {
    state.list.unshift(payload);
  },
  //
  
};

const actions = {
  meta: (store, params) => {
    store.state.isLoading = true;
    return service
      .get("alerts-and-notification/alerts-metadata", params)
      .then((data) => {
        store.commit("SET_META", data.body);
      })
      .finally(() => (store.state.isLoading = false));
  },
  list: (store, params) => {
    store.state.isLoading = true;
    return service
      .get("charger-maintenance/charger-maintenance-logs", params)
      .then((data) => {
        // store.commit("SET_META", data.body.meta);
        store.commit("SET_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
  
  add: (store, params) => {
    store.state.isLoading = true;
    return service
      .post("charger-maintenance/charger-maintenance-logs", params)
      .then((data) => {
        store.commit("ADD_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
  update: (store, params) => {
    store.state.isLoading = true;
    return service
      .put(`charger-maintenance/charger-maintenance-logs/${params.id}`, params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
  destroy: (store, params) => {
    store.state.isLoading = true;
    return service
      .destroy(`charger-maintenance/charger-maintenance-logs/${params.id}`)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.isLoading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
 
};

const chargerMaintaince = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default chargerMaintaince;
